export var source_sitemap = { "uid": "source_sitemap", "fields": { "title": { "defaultValue": "" } } };
